import { createFileRoute } from '@tanstack/react-router';

import { AttributesPage } from '@/features/catalog/AttributesPage';

/** Реестр атрибутов товаров — подчинённая страница каталога. */
export const Route = createFileRoute('/_app/catalog_/attributes')({
  component: AttributesPage,
});
